/**
 * 环境判断
 */
import * as dd from 'dingtalk-jsapi'
import gdt from 'gdt-jsapi'
import getCorpId from './getCorpId'

/**
 * 微信环境
 */
export const isWXEnv = () => {
  const match = window.navigator.userAgent
    .toLowerCase()
    .match(/MicroMessenger/i)
  return match && match.length && match.indexOf('micromessenger') !== -1
}

/**
 * 钉钉环境
 */
export const isDDEnv = () => dd.env.platform !== 'notInDingTalk'

/**
 * 政务钉钉 和 浙政钉 环境
 */
export const isGDTEnv = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.includes('taurusapp') && (ua.includes('saas') || ua.includes('zhejiang'))
}

/**
 * 钉钉初始化
 */
export const ddInit = () => {
  return new Promise((resolve, reject) => {
    getCorpId().then(corpId => {
      // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
      dd.ready(function () {
        dd.runtime.permission.requestAuthCode({
          corpId,
          onSuccess: function (result) {
            console.log('cc: ', result.code)
            resolve(result.code)
          },
          onFail: function (error) {
            console.log('onFail')
            reject(error)
          }
        })
      })
    })
  })
}

/**
 * 政务钉钉或浙政钉 初始化
 */
export const gdtInit = () => {
  return new Promise((resolve, reject) => {
    getCorpId().then(corpId => {
      console.log('corpId: ', corpId)
      // gdt.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
      gdt.ready(function () {
        gdt.getAuthCode({
          corpId
        }).then(result => {
          console.log('gdt get authCode success :>> ', result)
          resolve(result.code)
        }).catch(error => {
          console.log('gdt get authCode failed：', error)
          reject(error)
        })
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/env.js